import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgCommonModule } from '@principle-theorem/ng-shared';

@Component({
  selector: 'pr-account-summary-datapoint',
  templateUrl: './account-summary-datapoint.component.html',
  styleUrls: ['./account-summary-datapoint.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgCommonModule, MatTooltipModule, MatIcon],
})
export class AccountSummaryDatapointComponent {
  @Input() value: number;
  @Input() description: string;
  @Input() tooltip?: string;
}
